import axios, { AxiosRequestConfig } from 'axios';

const fallbackBaseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://ocppapi.goldtek.vn/api'
    : 'http://localhost:5000/api';

const configuredBaseUrl = process.env.REACT_APP_API_URL?.trim();

const baseURL = (configuredBaseUrl && configuredBaseUrl.length > 0
  ? configuredBaseUrl
  : fallbackBaseUrl
).replace(/\/$/, '');

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to include token
api.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const token = localStorage.getItem('token');
    console.log('Request Config:', config.url); // Debug log
    console.log('Token:', token); // Debug log
    
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
      console.log('Auth Header:', config.headers.Authorization); // Debug log
    }
    return config;
  },
  (error) => {
    console.error('Request Error:', error); // Debug log
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.error('Response Error:', error.response); // Debug log
    console.error('Error Config:', error.config); // Debug log
    
    // Don't redirect immediately, let's see the error first
    if (error.response?.status === 401 && !error.config.url.includes('/auth/login')) {
      console.error('Authentication failed:', error.response.data); // Debug log
      
      // Add a delay before redirect to see logs
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Vendor endpoints
export const getVendors = () => api.get('/vendors');
export const createVendor = (data: any) => api.post('/vendors', data);
export const updateVendor = (id: string, data: any) => api.put(`/vendors/${id}`, data);
export const deleteVendor = (id: string) => api.delete(`/vendors/${id}`);

export default api; 